import { fetchSubsiteAll } from '@/api/subsite'
import { getSubSiteId, setSubSiteId } from '@/utils/auth'

const state = {
  sidebar: {
    opened: true
  },
  subSiteList: [],
  subSiteId: getSubSiteId()
}

const mutations = {
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened
  },
  SET_SUB_SITE_LIST: (state, list) => {
    state.subSiteList = list || []
  },
  SET_SUB_SITE_ID: (state, id) => {
    state.subSiteId = id
    setSubSiteId(id)
  }
}

const actions = {
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  loadSubSites({ commit, state }) {
    return fetchSubsiteAll().then(list => {
      commit('SET_SUB_SITE_LIST', list)
      const ids = list.map(item => item.id)
      if (!ids.includes(state.subSiteId) && list.length) {
        commit('SET_SUB_SITE_ID', list[0].id)
      }
      return list
    })
  },
  setSubSiteId({ commit }, id) {
    commit('SET_SUB_SITE_ID', id)
  },
  setSubSiteList({ commit }, list) {
    commit('SET_SUB_SITE_LIST', list)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
